import React from 'react';
import { Entity } from '@backstage/catalog-model';
import {
  useEntity,
  MissingAnnotationEmptyState,
} from '@backstage/plugin-catalog-react';
import { Routes, Route } from 'react-router-dom';
import { COMPUTE_RESOURCES_METADATA } from './useProjectCode';
import { CrdPage } from './CrdPage';

/** @public */
export const isComputeResourceDiscoveryAvailable = (entity: Entity) =>
  Boolean(entity.metadata[COMPUTE_RESOURCES_METADATA]);

/** @public */
export const Router = () => {
  const { entity } = useEntity();

  if (!isComputeResourceDiscoveryAvailable(entity)) {
    return (
      <MissingAnnotationEmptyState
        annotation={`entity.metadata.${COMPUTE_RESOURCES_METADATA}`}
      />
    );
  }
  return (
    <Routes>
      <Route path="/" element={<CrdPage entity={entity} />} />
    </Routes>
  );
};
